import React from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Input,
} from "reactstrap";

function BankTransferModal({
  OnToggle,
  view,
  options,
  onChangeTransfer,
  cancel,
  transferPayment,
  updateTransfer,
}) {
  return (
    <div>
      <Modal isOpen={view} toggle={OnToggle} fullscreen={"false"}>
        <ModalBody>
          <Row xs="4">
            <Col>From Bank</Col>
            <Col>{transferPayment.frmBank}</Col>
            <Col>To Bank</Col>
            <Col>
              <Input
                bsSize="sm"
                className="mb-3"
                type="select"
                name="toBank"
                id="toBank"
                onChange={onChangeTransfer}
                value={transferPayment.toBank}
              >
                <option value="0">Select</option>
                {options.map((option) => {
                  if (option.bankName !== transferPayment.frmBank) {
                    return (
                      <option key={option.id} value={option.bankName}>
                        {option.bankName}
                      </option>
                    );
                  }
                })}
              </Input>
            </Col>
          </Row>
          <Row xs="4">
            <Col>Adjustment Date</Col>
            <Col>
              <Input
                bsSize="sm"
                className="mb-3"
                type="date"
                name="txnDate"
                id="txnDate"
                //style={{ width: "95px" }}
                onChange={onChangeTransfer}
                value={transferPayment.txnDate || ""}
              />
            </Col>
            <Col>Amount</Col>
            <Col>
              <Input
                bsSize="sm"
                className="mb-3"
                type="text"
                name="amount"
                id="amount"
                maxLength={7}
                onChange={onChangeTransfer}
                value={transferPayment.amount || ""}
              />
            </Col>
          </Row>
          <Row xs="4">
            <Col>Description</Col>
            <Col>
              <Input
                bsSize="sm"
                className="mb-3"
                type="textarea"
                name="desc"
                id="desc"
                onChange={onChangeTransfer}
                value={transferPayment.desc || ""}
              />
            </Col>
          </Row>
          <Row style={{ textAlign: "center" }}>
            <Col>
              <span id="transError" style={{ color: "red" }} />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={updateTransfer}>
            Update
          </Button>
          <Button color="secondary" onClick={cancel}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default BankTransferModal;



// WEBPACK FOOTER //
// ./src/components/CustomComponents/BankTransferModal.js